let animationLength = 0.5;
export function playerAnimation() {
  'ngInject';

  function getActors(element) {
    let nodes = element.querySelectorAll('.player,banner');
    //Nodes is returned in document order.
    let [banner, player] = [].slice.call(nodes);
    return {banner, player};
  }

  function checkClass(className) {
    return 'player-open' === className;
  }

  return {
    addClass: function (element, className, done) {
      if (checkClass(className)) {
        let {banner, player} = getActors(element[0]);
        let timeLine = new TimelineLite({paused: true}),
          bannerHeight = banner.offsetHeight,
          playerHeight = player.offsetHeight;

        timeLine.to(banner, animationLength, {
          opacity: 0,
          onComplete: function () {
            TweenLite.set(banner, {display: 'none'});
          }
        });
        timeLine.fromTo(player, animationLength, {
          height: bannerHeight,
          display: 'none',
          opacity: 0
        }, {
          height: playerHeight,
          display: 'block',
          opacity: 1
        });
        timeLine.eventCallback('onComplete', function () {
          done();
          window.setTimeout(function(){
            TweenLite.set(banner, {clearProps:'all'});
            TweenLite.set(player, {clearProps:'all'});
          },1);
        });
        timeLine.play();
      }
    },
    removeClass: function (element, className, done) {
      let {banner, player} = getActors(element[0]);
      let timeLine = new TimelineLite({paused: true}),
        bannerHeight = banner.offsetHeight,
        playerHeight = player.offsetHeight;

      timeLine.to(player, animationLength, {
        opacity: 0,
        onComplete: function () {
          TweenLite.set(player, {display: 'none'});
        }
      });
      timeLine.fromTo(banner, animationLength, {
        maxHeight: playerHeight,
        height: playerHeight,
        display: 'none',
        opacity: 0
      }, {
        height: bannerHeight,
        display: 'block',
        opacity: 1
      });
      timeLine.eventCallback('onComplete', function () {
        done();
        window.setTimeout(function(){
          TweenLite.set(banner, {clearProps:'all'});
          TweenLite.set(player, {clearProps:'all'});
        },1);
      });
      timeLine.play();
    }
  };
}




/** WEBPACK FOOTER **
 ** ./src/app/ecourse/ecourse.animation.js
 **/